import mainLogo from '@/assets/main-logo.png';
import footerLogo from '@/assets/main-logo.png';

export const logos = {
    main: mainLogo,
    footer: footerLogo,
    loader: footerLogo,
}

export const pageName = "BBT eCommerce";
export const pageSEOTitle = "BBT eCommerce";
export const pageSEODetails = "BBT eCommerce"
export const phoneNumber = "+88 017111111";

export const maxNavItem = 8;
export const maxNavItemMobile = 100;

export const poweredBy = {
    name: "Bit Byte Technology",
    link: "https://bitbytetechnology.com/",
}

export enum LoginMethod {
    social = "social",
    otp = "otp",
    normal = "normal",
}

// set true to enable login method
// set false to disable login method
export const loginMethods: {
    [key in LoginMethod]: boolean;
} = {
    [LoginMethod.normal]: true, // set false to disable normal login
    [LoginMethod.otp]: true, // set false to disable otp login
    [LoginMethod.social]: true, // set false to disable social login
}

export const imageSize = {
    width: 900,
    height: 900,
}